/**
 * Performance optimization utilities
 */

/**
 * Defer non-critical scripts
 */
export function deferScripts() {
  if (typeof window === 'undefined') return;

  // Defer analytics and non-critical scripts
  window.addEventListener('load', () => {
    // Load non-critical scripts after page load
    const scripts = document.querySelectorAll('script[data-defer]');
    scripts.forEach(script => {
      const newScript = document.createElement('script');
      newScript.src = script.getAttribute('data-src');
      newScript.async = true;
      document.body.appendChild(newScript);
    });
  });
}

/**
 * Preload critical resources
 */
export function preloadCriticalResources() {
  if (typeof window === 'undefined') return;

  const criticalResources = [
    // Add critical resource paths here
  ];

  criticalResources.forEach(resource => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.href = resource;
    link.as = 'fetch';
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });
}

/**
 * Optimize images on page load
 */
export function optimizeImages() {
  if (typeof window === 'undefined') return;

  // Use native lazy loading for images
  const images = document.querySelectorAll('img[data-src]');
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        img.src = img.getAttribute('data-src');
        img.removeAttribute('data-src');
        observer.unobserve(img);
      }
    });
  });

  images.forEach(img => imageObserver.observe(img));
}

/**
 * Initialize performance optimizations
 */
export function initPerformanceOptimizations() {
  if (typeof window === 'undefined') return;

  deferScripts();
  preloadCriticalResources();
  optimizeImages();
}







